import CircleType from 'circletype';

function arcHeadings() {
  const defaultArcHeadings = document.querySelectorAll('.arc-heading');
  const largeArcHeadings = document.querySelectorAll('.arc-heading-large');

  for (const element of defaultArcHeadings) {
    const circleType = new CircleType(element);
    circleType.radius(240).dir(1);
  }
  for (const element of largeArcHeadings) {
    const circleType = new CircleType(element);
    circleType.radius(140).dir(1);
  }
}

arcHeadings();
